export enum FileUploadState {
  NotStarted,
  PreparationComplete,
  Error,
  UploadComplete,
  Complete,
}
